import { render, staticRenderFns } from "./OrganismGuidedTourPresentationDrawer.vue?vue&type=template&id=e067b3ce&"
import script from "./OrganismGuidedTourPresentationDrawer.vue?vue&type=script&lang=js&"
export * from "./OrganismGuidedTourPresentationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OrganismGuidedTourPresentationDrawer.vue?vue&type=style&index=0&id=e067b3ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismGuidedTourPresentationDrawer.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Forganisms%2Fproject%2Fbuilding%2FOrganismGuidedTourPresentationDrawer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingGuidedTourMoleculeContentBlocks: require('/app/components/molecules/project/building/guidedTour/MoleculeContentBlocks.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,OrganismsCommonOrganismDrawer: require('/app/components/organisms/common/OrganismDrawer.vue').default})
